/* Product-template main script — externalized + deferred 2026-08-19 (was 12.5KB inline on every PDP). section.id/product.id/product.title passed via #cpg-product-main-config JSON block; code is Liquid-free + cacheable. Defines no globals; interaction-only, so defer runs it after parse. */
(function () {
  var CPG_PRODUCT_CFG = (function(){ try { return JSON.parse(document.getElementById('cpg-product-main-config').textContent); } catch(e){ return {}; } })();

  var section = document.getElementById('cpg-product-' + CPG_PRODUCT_CFG.sectionId);
  if (!section) return;

  /* star bars: rating value -> red-fill width (rating/5) */
  function paintStars() {
    section.querySelectorAll('[data-cpg-stars]').forEach(function (el) {
      var v = parseFloat(el.getAttribute('data-cpg-stars')) || 0;
      el.style.setProperty('--fill', Math.max(0, Math.min(100, (v / 5) * 100)) + '%');
    });
    section.querySelectorAll('[data-cpg-bar]').forEach(function (el) {
      var w = parseFloat(el.getAttribute('data-cpg-bar')) || 0;
      el.style.setProperty('--w', Math.max(0, Math.min(100, w)) + '%');
    });
  }

  /* fitment context bar + "My vehicle only" label, from the shopper's active vehicle */
  function paintContext() {
    var veh = activeVehicleText();
    var ctx = section.querySelector('[data-cpg-reviews-ctx]');
    var ctxVeh = section.querySelector('[data-cpg-reviews-ctx-veh]');
    if (ctx) {
      ctx.hidden = false; // always shown — has a no-vehicle variant so it never truncates
      if (ctxVeh) ctxVeh.textContent = veh
        ? ('green when it matches your ' + veh)
        : 'add your vehicle and matching reviews turn green.';
    }
  }

  function activeVehicleText() {
    try {
      if (window.CPGFitment && window.CPGFitment.getVehicleText) {
        var t = window.CPGFitment.getVehicleText();
        if (t) return t;
      }
      var raw = localStorage.getItem('cpg:garage:vehicle');
      if (raw) { var v = JSON.parse(raw); return [v.year, v.make, v.model, v.submodel].filter(Boolean).join(' '); }
    } catch (e) {}
    return '';
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }

  /* v5.3 rule: a review's vehicle chip goes GREEN only on a true match to the
     shopper's active vehicle; grey otherwise. */
  function markVehicleChips() {
    var av = norm(activeVehicleText());
    section.querySelectorAll('[data-cpg-review]').forEach(function (card) {
      var rv = norm(card.getAttribute('data-cpg-review-vehicle'));
      var chip = card.querySelector('[data-cpg-review-veh-chip]');
      var isMatch = false;
      if (av && rv) {
        var shared = rv.split(' ').filter(function (w) { return w && av.indexOf(w) !== -1; }).length;
        isMatch = rv.indexOf(av) !== -1 || av.indexOf(rv) !== -1 || shared >= 3;
      }
      if (chip) chip.classList.toggle('is-match', isMatch);
      card.setAttribute('data-cpg-review-match', isMatch ? 'true' : 'false');
    });
    var mv = section.querySelector('[data-cpg-rfilter="vehicle"]');
    if (mv && !mv.dataset.cpgInit) {
      mv.dataset.cpgInit = '1';
      // only pre-check "My vehicle only" when there are REAL reviews to filter — otherwise
      // an empty list is ambiguous (is it empty, or filtered-empty?).
      var hasReal = section.querySelectorAll('[data-cpg-review]').length > 0;
      if (av && hasReal) { mv.checked = true; }
    }
    applyFilters();
  }

  function applyFilters() {
    var f = {};
    section.querySelectorAll('[data-cpg-rfilter]').forEach(function (cb) { f[cb.getAttribute('data-cpg-rfilter')] = cb.checked; });
    var shown = 0, total = 0;
    section.querySelectorAll('[data-cpg-review]').forEach(function (card) {
      total += 1;
      var ok = true;
      if (f.vehicle && card.getAttribute('data-cpg-review-match') !== 'true') ok = false;
      if (f.verified && card.getAttribute('data-cpg-review-verified') !== 'true') ok = false;
      if (f.photos && card.getAttribute('data-cpg-review-photos') !== 'true') ok = false;
      if (f.fitment && card.getAttribute('data-cpg-review-fitment') !== 'true') ok = false;
      card.hidden = !ok;
      if (ok) shown += 1;
    });
    var empty = section.querySelector('[data-cpg-reviews-empty]');
    if (empty && total > 0) empty.hidden = shown > 0;
  }
  section.querySelectorAll('[data-cpg-rfilter]').forEach(function (cb) { cb.addEventListener('change', applyFilters); });

  /* write-a-review modal */
  var pop = section.querySelector('[data-cpg-review-popup]');
  section.querySelectorAll('[data-cpg-review-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!pop) return;
      var vi = pop.querySelector('[data-cpg-review-vehicle-input]');
      if (vi) vi.value = activeVehicleText();
      pop.classList.add('is-open');
    });
  });
  if (pop) {
    pop.querySelectorAll('[data-cpg-review-close]').forEach(function (b) { b.addEventListener('click', function () { pop.classList.remove('is-open'); }); });
    pop.addEventListener('click', function (e) { if (e.target === pop) pop.classList.remove('is-open'); });
    var ratingInput = pop.querySelector('[data-cpg-review-rating-input]');
    pop.querySelectorAll('.cpg-review-star').forEach(function (star) {
      star.addEventListener('click', function () {
        var v = parseInt(star.getAttribute('data-star'), 10);
        if (ratingInput) ratingInput.value = v;
        pop.querySelectorAll('.cpg-review-star').forEach(function (s) {
          s.classList.toggle('is-on', parseInt(s.getAttribute('data-star'), 10) <= v);
        });
      });
    });
  }

  /* seeded Q&A: a seed opens the ask modal (data-pqa-open) and prefills the question */
  section.querySelectorAll('[data-pqa-seed]').forEach(function (seed) {
    seed.addEventListener('click', function () {
      var q = seed.getAttribute('data-pqa-seed') || '';
      window.setTimeout(function () {
        var ta = section.querySelector('[data-pqa-popup] textarea[name="contact[body]"], [data-pqa-popup] textarea');
        if (ta) { ta.value = q; try { ta.focus(); } catch (e) {} }
      }, 80);
    });
  });

  /* The sidebar reflects REAL reviews only — an empty skeleton ("No reviews yet", greyed
     bars, no sub-scores) when there are none. The labelled SAMPLE cards below carry the
     example; the sidebar must never show a fabricated average. */

  /* Filter rules:
     - 'My vehicle only' is DISABLED with "Add a vehicle to filter" when no vehicle is set
       (never an active checkbox filtering against nothing); active with the vehicle name
       once one is chosen.
     - verified / photos / fitment options hide unless a real review matches them
       (so 'With photos' stays hidden until photo reviews exist).
     - the whole block hides only when there is nothing to offer at all. */
  function syncFilters() {
    var filters = section.querySelector('.cpg-reviews__filters');
    if (!filters) return;
    var reviews = section.querySelectorAll('[data-cpg-review]');
    var veh = activeVehicleText();
    var attrMap = { verified: 'data-cpg-review-verified', photos: 'data-cpg-review-photos', fitment: 'data-cpg-review-fitment' };
    var anyShown = false;
    section.querySelectorAll('.cpg-reviews__filter').forEach(function (label) {
      var cb = label.querySelector('[data-cpg-rfilter]');
      var key = cb && cb.getAttribute('data-cpg-rfilter');
      var span = label.querySelector('span');
      if (key === 'vehicle') {
        if (cb) { cb.disabled = !veh; if (!veh) cb.checked = false; }
        label.classList.toggle('is-disabled', !veh);
        if (span) span.innerHTML = veh ? ('My vehicle only <em>(' + veh + ')</em>') : 'Add a vehicle to filter';
        label.hidden = false; anyShown = true; return;
      }
      var attr = attrMap[key];
      var match = attr && Array.prototype.some.call(reviews, function (r) { return r.getAttribute(attr) === 'true'; });
      label.hidden = !match;
      if (match) anyShown = true;
    });
    filters.hidden = !anyShown;
  }

  /* Submit review / question to the custom pipeline API (Option A) instead of the
     Shopify contact-email. Stored pending; a moderation email approves & publishes. */
  var CPG_REVIEWS_API = 'https://carpartglobal-api-2wqerijrtq-uc.a.run.app';
  var CPG_PRODUCT_ID = String(CPG_PRODUCT_CFG.productId);
  var CPG_PRODUCT_TITLE = CPG_PRODUCT_CFG.productTitle;

  /* "Was this helpful?" — deliberately cheap. Nothing runs at page load: the counts are
     already rendered from the metafield and the row id ships with them, so a vote needs no
     lookup. One fire-and-forget POST per click; the count updates optimistically so the
     shopper never waits on the network. localStorage stops a second click reaching it at all.
     A repeat vote is also a no-op server-side (UNIQUE on kind+row+voter). */
  section.querySelectorAll('[data-cpg-helpful]').forEach(function (box) {
    var kind = box.getAttribute('data-cpg-helpful');
    var rowId = parseInt(box.getAttribute('data-cpg-helpful-id'), 10);
    if (!rowId) return;                       /* unpublished/sample rows carry no id */
    var key = 'cpg-helpful:' + kind + ':' + rowId;
    var already = false;
    try { already = !!window.localStorage.getItem(key); } catch (e) {}   /* private mode */
    if (already) box.classList.add('is-voted');

    box.querySelectorAll('[data-cpg-helpful-vote]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (box.classList.contains('is-voted')) return;
        var yes = btn.getAttribute('data-cpg-helpful-vote') === 'yes';
        box.classList.add('is-voted');
        btn.classList.add('is-chosen');
        try { window.localStorage.setItem(key, yes ? 'yes' : 'no'); } catch (e) {}
        var c = btn.querySelector('[data-cpg-helpful-count]');
        if (c) {
          var n = parseInt((c.textContent || '').replace(/[^0-9]/g, ''), 10) || 0;
          c.textContent = ' (' + (n + 1) + ')';
        }
        fetch(CPG_REVIEWS_API + '/storefront/helpful', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ kind: kind, id: rowId, helpful: yes })
        }).catch(function () {});             /* the vote is a nicety, never an error state */
      });
    });
  });

  function submitToApi(form, url, payload) {
    var btn = form.querySelector('[type="submit"], button[type="submit"], .cpg-review-popup__submit, .custom-pqa__submit');
    if (btn) { btn.dataset.orig = btn.textContent; btn.disabled = true; btn.textContent = 'Submitting…'; }
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.ok) {
          form.innerHTML = '<p style="padding:18px 0;font-size:15px;color:#16a34a;font-weight:600">' + (d.message || 'Thanks! Submitted for review.') + '</p>';
        } else { throw new Error((d && d.error) || 'Submission failed.'); }
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.orig || 'Submit'; }
        window.alert(err.message || 'Could not submit — please try again.');
      });
  }

  if (pop) {
    var reviewForm = pop.querySelector('form');
    if (reviewForm) {
      reviewForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var f = new FormData(reviewForm);
        var ratingEl = reviewForm.querySelector('[data-cpg-review-rating-input]');
        submitToApi(reviewForm, CPG_REVIEWS_API + '/storefront/reviews/submit', {
          productId: CPG_PRODUCT_ID, productTitle: CPG_PRODUCT_TITLE,
          rating: ratingEl ? ratingEl.value : '',
          title: f.get('contact[Review Title]') || '',
          body: f.get('contact[body]') || '',
          name: f.get('contact[name]') || '',
          email: f.get('contact[email]') || '',
          vehicle: f.get('contact[Vehicle]') || ''
        });
      });
    }
  }
  var qaPop = section.querySelector('[data-pqa-popup]');
  if (qaPop) {
    var qaForm = qaPop.querySelector('form');
    if (qaForm) {
      qaForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var f = new FormData(qaForm);
        submitToApi(qaForm, CPG_REVIEWS_API + '/storefront/qa/submit', {
          productId: CPG_PRODUCT_ID, productTitle: CPG_PRODUCT_TITLE,
          question: f.get('contact[body]') || '',
          name: f.get('contact[name]') || '',
          email: f.get('contact[email]') || '',
          vehicle: activeVehicleText()
        });
      });
    }
  }

  function refreshAll() { paintStars(); paintContext(); syncFilters(); markVehicleChips(); }
  refreshAll();
  ['cpg:vehicle-changed', 'vehicleSelected', 'vehicleChanged', 'garageChanged'].forEach(function (ev) {
    window.addEventListener(ev, refreshAll);
    document.addEventListener(ev, refreshAll);
  });
})();
